var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"row"},_vm._l((_vm.columns),function(col){return _c('th',{key:col.column || col.label,staticClass:"column"},[_c('p',{staticClass:"column__label"},[_vm._v(_vm._s(col.label))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }